
function Loading() {
    return (
        <div>LOADING</div>
    )
}

export default Loading
